import { api } from "../api";
import { CommandSentResponseType, SendCommandType } from "../../../types/types";

/**
 * sendCommandByIdMqtt - Function that sends to server a command to be emitted to tracker device  
 * /devices/commands/send/mqtt
 * method POST 
 * @async-function
 */
const sendCommandByIdMqtt = async (model: SendCommandType) => {
    const response = await api.post<CommandSentResponseType>(
        `/devices/commands/send/mqtt?isCommandLine=${model.isCommandLine}&deviceType=${model.deviceType}`, {
            description: model.commandDesc,
            deviceId: model.deviceId,
            deviceImei: model.deviceImei,
            customerId: model.customerId,
            name: model.name,
            email: model.email,
            cameraOptions: model.cameraConfig
        }, {
            headers: {
                'Authorization': `Bearer ${model.token}`
            }
        }
    );
    return response;
};

export default sendCommandByIdMqtt;
